import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { IconComponent, IconName, RtTooltip } from '@core/user-interface-legacy';

@Component({
  selector: 'tlc-app-shell-topbar-button',
  styleUrl: './tellent-app-shell-topbar-button.component.less',
  template: `
    @let isActiveVal = isActive();
    <div class="inner" [class.active]="isActiveVal" rtTooltip [rtTooltipTemplate]="tooltipTemplate">
      <rt-icon
        [size]="'medium'"
        [name]="isActiveVal ? iconName() : (iconNameActive() ?? iconName())"
      />

      <ng-template #tooltipTemplate>
        <span>
          <strong>
            {{ label() }}
          </strong>
        </span>
      </ng-template>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, RtTooltip],
})
export class TellentAppShellTopbarButtonComponent {
  public iconName = input.required<IconName>();
  public label = input.required<string>();
  public iconNameActive = input<IconName>();
  public isActive = input<boolean>(false);
}
